import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/bac-calculator',
  component: () => import('../../routes/BACCalculator.svelte'),
  card: {
    id: 'bac-calculator',
    title: 'Blood Alcohol Content (BAC)',
    description: 'Estimate your BAC based on drinks consumed, body weight, and time. See how long until you\'re sober and understand impairment levels.',
    icon: 'water_drop',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/bac-calculator',
    category: 'Health & Fitness',
  },
  seo: {
    title: 'Blood Alcohol Content (BAC) Calculator – Estimate Your BAC Level',
    description: 'Free BAC calculator to estimate your blood alcohol content. Enter drinks, weight, sex, and time to see your BAC, impairment level, and hours until sober.',
  },
};

export default meta;